import {useEffect, useState} from 'react';
import assetFetchers from '@/api/fetchers/content-studio/asset';
import {Asset} from '@/views/content-studio/components/asset-table/types';
import useDataQuery from '@/hooks/use-data-query';
import {CONTENT_LAB, ASSETS} from '../consts';

interface AssetQueryParams {
  id: string;
  enabled?: boolean;
  onAssetLoad?: (asset: Asset, error?: Error) => void;
}

function useAssetQuery({id, enabled = true, onAssetLoad}: AssetQueryParams) {
  const [assetLoaded, setAssetLoaded] = useState(false);
  const response = useDataQuery<Asset>({
    queryKey: [CONTENT_LAB, ASSETS, id],
    queryFn: () => assetFetchers.getAssetById(id),
    enabled: !!id && enabled,
  });

  useEffect(() => {
    setAssetLoaded(false);
  }, [id, enabled]);

  useEffect(() => {
    if (!assetLoaded && response.data && onAssetLoad) {
      setAssetLoaded(true);
      onAssetLoad(response.data);
    }
  }, [response.data, assetLoaded, onAssetLoad]);

  return response;
}

export default useAssetQuery;
